<template>
  <div class="w-full">
    <div
      v-if="props.params.data.product"
      class="flex items-center justify-between w-full"
    >
      <Link
        :href="route('products.show', { product: props.params.data.product.id })"
        class="uppercase font-semibold text-blue-600 hover:text-blue-600 truncate"
      >
        {{ props.params.data.product.name }}
      </Link>

      <button
        class="shrink-0 inline-flex items-center px-3 py-1 border border-transparent text-sm font-medium rounded-md text-blue-600"
        @click="assign()"
      >
        <PencilIcon size="12" />
      </button>
    </div>
    <button
      v-else
      class="w-full inline-flex items-center justify-center px-4 py-1 border border-transparent text-sm font-medium rounded-md shadow-sm bg-gray-200 text-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 h-full"
      @click="assign()"
    >
      Pair Product
    </button>
  </div>
</template>
<script setup>
import { Link } from '@inertiajs/vue3'
import { PencilIcon } from 'lucide-vue-next'

/**
 * @typedef {Object} PairProductCellParams
 * @property {Function} actionFunction
 */
const props = defineProps({
  /** @type {PairProductCellParams} */
  params: {
    type: Object,
    required: true
  }
})

const assign = () => {
  props.params.actionFunction(props.params.data)
}
</script>
